import PropTypes from 'prop-types';
import getIn from 'immutable-less/transmute/getIn';
import { useQuery } from 'data-fetching-client';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITruncateString from 'UIComponents/text/UITruncateString';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped module

// @ts-expect-error untyped module
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { COMPANY_ID, DEAL_ID, TICKET_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { isCustomObject } from 'automation-ui-references/object-types/objectTypeUtils';
import { OBJECT_TIMELINE_EVENTS_FIELDNAME, GET_TIMELINE_EVENTS_FOR_OBJECT } from 'automation-ui-enrollment/queries/ObjectTimelineQueries';
import DocButton from 'automation-ui-usage-tracking/components/DocButton';
import { SupportLinkKeys } from 'automation-ui-usage-tracking/SupportLinks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MergeStatusPropTypes = {
  reference: PropTypes.object.isRequired,
  objectTypeId: ObjectTypeIdType.isRequired,
  mergeAuditCutoff: PropTypes.number
};
const getMergeAudits = record => getIn(['referencedObject', 'mergeAudits'], record);
const getPertinentTimelineEventData = event => {
  const {
    mergedObjectSummaryValues
  } = event;
  const email = mergedObjectSummaryValues.find(summaryVal => summaryVal.name === 'email');
  const firstName = mergedObjectSummaryValues.find(summaryVal => summaryVal.name === 'firstName');
  const lastName = mergedObjectSummaryValues.find(summaryVal => summaryVal.name === 'lastName');
  return email && email.value || lastName && firstName && `${firstName.value} ${lastName.value}` || null;
};
const getMergeSummary = (eventData, objectTypeId) => {
  const eventLabel = getPertinentTimelineEventData(eventData);
  return /*#__PURE__*/_jsxs("p", {
    children: [/*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx("label", {
        children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "automation-ui-enrollment.history.log-events.merged-object.summary-label_cob",
          objectTypeId: objectTypeId
        })
      })
    }), eventLabel]
  });
};
const getSupportLinkKey = objectTypeId => {
  if (isCustomObject(objectTypeId)) {
    return SupportLinkKeys.MERGE_CUSTOM_OBJECTS;
  }
  switch (objectTypeId) {
    case COMPANY_ID:
      return SupportLinkKeys.MERGE_COMPANIES;
    case DEAL_ID:
      return SupportLinkKeys.MERGE_DEALS;
    case TICKET_ID:
      return SupportLinkKeys.MERGE_TICKETS;
    default:
      return SupportLinkKeys.MERGE_CONTACTS;
  }
};
const MergeStatus = ({
  reference,
  objectTypeId,
  mergeAuditCutoff
}) => {
  const mergeAudits = getMergeAudits(reference);
  const {
    data
  } = useQuery(GET_TIMELINE_EVENTS_FOR_OBJECT, {
    variables: {
      objectTypeId,
      objectId: reference.id
    },
    skip: !mergeAudits
  });
  if (!mergeAudits) {
    return null;
  }
  const Label = /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: "automation-ui-enrollment.history.log-events.merged-object.label_cob",
    objectTypeId: objectTypeId
  });
  const events = data && data[OBJECT_TIMELINE_EVENTS_FIELDNAME] && data[OBJECT_TIMELINE_EVENTS_FIELDNAME].mergeAudits || [];
  if (mergeAuditCutoff) {
    events.filter(event => event.timestamp <= mergeAuditCutoff);
  }
  const event = events.length && events[0] || null;
  if (!event) {
    return null;
  }
  return /*#__PURE__*/_jsx(Small, {
    use: "help",
    children: /*#__PURE__*/_jsx(UITruncateString, {
      useFlex: true,
      tooltip: false,
      fixedChildren: /*#__PURE__*/_jsx(UITooltip, {
        use: "longform",
        headingText: Label,
        maxWidth: 300,
        title: /*#__PURE__*/_jsxs(_Fragment, {
          children: [getMergeSummary(event, objectTypeId), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(DocButton, {
              supportKey: getSupportLinkKey(objectTypeId),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation-ui-enrollment.history.log-events.merged-object.learn-more"
              })
            })
          })]
        }),
        placement: "bottom",
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "info",
          className: "m-left-1",
          size: 12
        })
      }),
      children: Label
    })
  });
};
MergeStatus.propTypes = MergeStatusPropTypes;
export default MergeStatus;